"use strict";

exports.__esModule = true;
exports.TYPE = exports.SIZE = exports.LABEL_POSITION = void 0;
var LABEL_POSITION = {
  start: 'start',
  end: 'end'
};
exports.LABEL_POSITION = LABEL_POSITION;
var SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  jumbo: 'jumbo'
};
exports.SIZE = SIZE;
var TYPE = {
  checkbox: 'checkbox',
  radio: 'radio'
};
exports.TYPE = TYPE;